/* eslint-disable react/no-danger */
import moment from 'moment';
import { useNavigate, useParams } from 'react-router-dom';
import { useRef } from 'react';
import { IChangeHistoryLayout } from '../../types/layout/change-history';
import { useChangeHistory } from '../../hooks/change-history/useChangeHistory';
import Loader from '../loader';
import Modal, { IModalRefs } from '../modal';

function ChangeHistory(props: IChangeHistoryLayout) {
    const { actions, primaryKey } = props;

    const {
        data, loading, getData, rowDelete,
    } = useChangeHistory(props);

    const { objectId: idOwner } = useParams();

    const navigate = useNavigate();

    const modal = useRef<IModalRefs>();

    const onCreateClick = () => {
        if (actions?.create) {
            if (typeof actions?.create === 'string') {
                navigate(actions.create);
            } else if (typeof actions.create === 'object') {
                if (actions.create.type === 'modal') {
                    modal.current?.show(actions.create.layoutLink, null, idOwner);
                }
            }
        }
    };

    const onEditClick = (row: Record<string, any>) => {
        if (actions && actions.edit && typeof primaryKey === 'string') {
            if (typeof actions.edit === 'string') {
                navigate(actions.edit.replace('{objectId}', row[primaryKey]));
            } else if (typeof actions.edit === 'object') {
                if (actions.edit.type === 'modal') {
                    modal.current?.show(actions.edit.layoutLink, row[primaryKey], idOwner);
                }
            }
        }
    };

    if (loading) {
        return (
            <Loader loading />
        );
    }

    return (
        <>
            {actions?.create && (
                <button className="btn btn-outline-primary btn-sm mb-2" type="button" onClick={() => onCreateClick()}>
                    <i className="fa fa-plus" />
                </button>
            )}
            {Array.isArray(data) && data.length > 0 && data.map((item, index) => (
                <div key={index} className={index < data.length - 1 ? 'mb-3 change-history-item' : 'change-history-item'}>
                    <div className="d-flex flex-row justify-content-between">
                        <div className="d-flex flex-column flex-grow-1 text-break mr-2">
                            <div dangerouslySetInnerHTML={{ __html: item.title }} />
                            <div dangerouslySetInnerHTML={{ __html: item.content }} />
                        </div>
                        <div className="d-flex flex-column">
                            <div className="change-history-item-date">{moment(item.date).format('DD.MM.YYYY HH:mm')}</div>
                            <div className="d-flex flex-row justify-content-end">
                                {actions?.edit && (
                                    <button className="btn p-0 mr-2" type="button" onClick={() => onEditClick(item)}>
                                        <i className="fa fa-edit" />
                                    </button>
                                )}
                                {typeof actions?.delete === 'string' && (
                                    <button className="btn p-0" type="button" onClick={() => rowDelete(item)}>
                                        <i className="fa fa-trash" />
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            ))}
            {(!data || (Array.isArray(data) && data.length === 0)) && (
                <div className="change-history-item text-center">
                    Данных нет
                </div>
            )}

            <Modal ref={modal} idOwner={idOwner} onHide={getData} />
        </>
    );
}

export default ChangeHistory;
